module.exports = __webpack_public_path__ + "img/fuwuzhongxin2.eee437de.png";